export const bulbDefaultColor = "#e41a1c";

/*
export const BulbColors = {
    red: "#e41a1c",
    blue: "#377eb8",
    green: "#4daf4a",
    purple: "#984ea3",
    orange: "#ff7f00",
    yellow: "#ffff33",
    brown: "#a65628",
    pink: "#f781bf",
    white: "#ffffff",
};
*/



// WEBPACK FOOTER //
// ./src/components/searchpage/PocketBulb.js